import React from 'react';

import { VisitorPageSectionsMapper } from '../sections';

import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import challengeSettings from '../../../../../settingsParams';
import { useSidebarItems } from '../../../../../Settings/tabs/Sections/components/VisitorV2SectionsTabContent/constants/splitItemsHelper';

import { st, classes } from './VisitorPageSidebar.st.css';
import { FCWithChildren } from '@wix/challenges-web-library';
import { useCSSPBEnabled } from '../../../../../../../hooks/useCSSPBStyle';
import { useUser } from '../../../../../../../contexts/User/UserContext';
import { isUserRequestedToJoin } from '../../../../../../../contexts/User/helpers/userTypeHandlers';

interface IVisitorPageSidebarProps {
  className?: string;
  sectionClassName?: string;
  boxElementClassName?: string;
  startDateLabelClassName?: string;
}

export const VisitorPageSidebar: FCWithChildren<IVisitorPageSidebarProps> = ({
  className = null,
  sectionClassName = null,
  boxElementClassName = null,
  startDateLabelClassName = null,
}) => {
  const { isMobile } = useEnvironment();
  const { userType } = useUser();
  const settings = useSettings();
  const cssPBEnabled = useCSSPBEnabled();
  const isSidebarEnabled =
    cssPBEnabled ||
    !!settings.get(challengeSettings.visitorPageBodyEnableSidebar);
  const sidebarItems = useSidebarItems();
  const sidebarItemsIds = sidebarItems.map((item) => item.id);
  const alignmentWhenDesktop = cssPBEnabled
    ? null
    : settings.get(challengeSettings.visitorPageBodySidebarTextAlignment);
  const alignment = isMobile
    ? settings.get(challengeSettings.contentTextAlignment)
    : alignmentWhenDesktop;
  return (
    <aside
      className={st(
        classes.root,
        {
          mobile: isMobile,
          // for mobile we get the alignment from the base content
          sidebarTextAlignment: alignment,
        },
        cssPBEnabled ? classes.opgVisitorPageBodyEnableSidebar : undefined,
        className,
      )}
      data-hook="visitor-page-sidebar"
    >
      {isSidebarEnabled ? (
        <>
          <VisitorPageSectionsMapper
            sections={sidebarItemsIds}
            sectionClassName={sectionClassName}
            boxElementClassName={boxElementClassName}
            startDateLabelClassName={startDateLabelClassName}
            alignment={alignment}
            isUserRequestedToJoin={isUserRequestedToJoin(userType)}
          />
        </>
      ) : null}
    </aside>
  );
};
